import { cn } from '@/lib/utils';
import { RANGES, type TrafficRange } from './range';

/**
 * One range control per surface, above everything it scopes.
 *
 * `5m` is deliberately not a preset: at a 120s poll cadence floored at 300s it
 * is two to five points pretending to be a trend, and it structurally cannot
 * answer "since when".
 *
 * Shared across the interface, link and node panels so all three agree about
 * what window they are describing, and shaped as a controlled component so the
 * Views page can lift it into the page filter row without any of them changing.
 */
export function RangeControl({
  value,
  onChange,
}: {
  value: TrafficRange;
  onChange: (range: TrafficRange) => void;
}) {
  return (
    <div className="inline-flex rounded-md border border-border overflow-hidden" role="group" aria-label="Time range">
      {RANGES.map((range) => (
        <button
          key={range}
          type="button"
          onClick={() => { onChange(range); }}
          aria-pressed={value === range}
          className={cn(
            'px-2.5 py-1 text-xs border-r border-border last:border-r-0',
            value === range ? 'bg-muted text-foreground font-medium' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {range}
        </button>
      ))}
    </div>
  );
}
